"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SEARCH_NAME = exports.XGridTableStyle = void 0;
var XGridTableStyle;
(function (XGridTableStyle) {
    XGridTableStyle["PRIMARY"] = "PRIMARY";
    XGridTableStyle["SECONDARY"] = "SECONDARY";
    XGridTableStyle["TERTIARY"] = "TERTIARY";
    XGridTableStyle["QUATERNARY"] = "QUATERNARY";
})(XGridTableStyle = exports.XGridTableStyle || (exports.XGridTableStyle = {}));
exports.DEFAULT_SEARCH_NAME = 'Search';
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMveC1ncmlkL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLGVBS1g7QUFMRCxXQUFZLGVBQWU7SUFDekIsc0NBQW1CLENBQUE7SUFDbkIsMENBQXVCLENBQUE7SUFDdkIsd0NBQXFCLENBQUE7SUFDckIsNENBQXlCLENBQUE7QUFDM0IsQ0FBQyxFQUxXLGVBQWUsR0FBZix1QkFBZSxLQUFmLHVCQUFlLFFBSzFCO0FBRVksUUFBQSxtQkFBbUIsR0FBRyxRQUFRLENBQUMifQ==